import { $ } from '../../modules/dom.js';
import { validarCamposPersona } from './validaciones.js';
import { buscarPersona } from './buscar.js';



document.addEventListener('DOMContentLoaded', function () {
    const campos = {
        identidad: $('#identidad'),
        nombre: $('#nombre'),
        telefono: $('#telefono'),
        mensaje: $('#mensaje-identidad')
    };

    if (!campos.identidad || !campos.nombre || !campos.telefono || !campos.mensaje) {
        return;
    }

    validarCamposPersona(campos);
    buscarPersona(campos);
});